module.exports = __webpack_public_path__ + "img/verbs-cover.51dcf080.jpg";